import React from 'react'

import PropTypes from 'prop-types'

import styles from './style.module.scss'
import { convertDate, dateCheck } from '@shared-submodule/utils'
// import weatherIcon from '@assets/images/icon/weather-icon.svg'
// import outfieldIcon from '@assets/images/icon/outfield-icon.svg'
// import pitchIcon from '@assets/images/icon/pitch-icon.svg'

const MatchInfo = ({ data }) => {
  return (
    <section className={`${styles.matchInfo}`}>
      <div className={`${styles.list} font-semi common-box mb-0 p-3 overflow-hidden`}>
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Series</p>
          <p className="mb-0">{data?.oSeries?.sTitle || '-'}</p>
        </div>
        {/* <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>
            Match
          </p>
          <p className="mb-0">{data?.sTitle || '-'}</p>
        </div> */}
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Date &amp; Time</p>
          <p className="mb-0">{convertDate(dateCheck(data?.dStartDate)) || '-'}</p>
        </div>
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Toss</p>
          <p className="mb-0">{data?.oToss?.sText || '-'}</p>
        </div>
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Venue</p>
          <p className="mb-0">{data?.oVenue?.sName || '-'}</p>
        </div>
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Umpires</p>
          <p className="mb-0">{data?.sUmpires || '-'}</p>
        </div>
        <div className={`${styles.item} d-flex`}>
          <p className={`${styles.label} mb-0 text-muted flex-shrink-0`}>Match Referee</p>
          <p className="mb-0">{data?.sReferee || '-'}</p>
        </div>
        {/* <div className={`${styles.item} ${styles.infoItem} d-flex flex-column flex-lg-row`}>
          <div className="d-flex flex-lg-column justify-content-between align-items-center align-items-lg-start flex-grow-1">
            <div className={`${styles.info} d-flex align-items-center text-muted`}>
              <div className={`${styles.icon}`}>
                <MyImage src={weatherIcon} alt="WEATHER" layout="responsive" />
              </div>
              <p className="mb-0">WEATHER CONDITION</p>
            </div>
            <p className="mb-0">Overcast</p>
          </div>
          <div className="d-flex flex-lg-column justify-content-between align-items-center align-items-lg-start flex-grow-1">
            <div className={`${styles.info} d-flex align-items-center text-muted`}>
              <div className={`${styles.icon}`}>
                <MyImage src={outfieldIcon} alt="outfield" layout="responsive" />
              </div>
              <p className="mb-0">WEATHER CONDITION</p>
            </div>
            <p className="mb-0">Dry</p>
          </div>
          <div className="d-flex flex-lg-column justify-content-between align-items-center align-items-lg-start flex-grow-1">
            <div className={`${styles.info} d-flex align-items-center text-muted`}>
              <div className={`${styles.icon}`}>
                <MyImage src={pitchIcon} alt="pitch" layout="responsive" />
              </div>
              <p className="mb-0">WEATHER CONDITION</p>
            </div>
            <p className="mb-0">Fast</p>
          </div>
        </div> */}
      </div>
    </section>
  )
}

MatchInfo.propTypes = {
  data: PropTypes.object
}

export default MatchInfo
